import BaseService from "./BaseService";

export default class CorridorService extends BaseService {

    public static getCorridorList(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'recipient/get-corridor-list', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static updateCorridorStatus(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}recipient/update-corridor-status`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }
}